/**
 * Authentication Configuration
 * 
 * Google Client IDs are public and safe to hardcode.
 * They identify your app to Google but are not secrets.
 */

export const GOOGLE_AUTH_CONFIG = {
  // Web Client ID - used for web app and Electron
  // Also used by backend for token verification
  WEB_CLIENT_ID: '888442166156-rotbbitji70ro5s7m35nask0muat6h16.apps.googleusercontent.com',
  
  // iOS Client ID - for native iOS app (optional, create when deploying iOS)
  // Leave empty until you create an iOS OAuth Client ID in Google Cloud Console
  IOS_CLIENT_ID: '888442166156-r9fm4k0hnfaq3965q7qcu71ppe1f0jtl.apps.googleusercontent.com',
  
  // Android Client ID - for native Android app (optional, create when deploying Android)
  // Leave empty until you create an Android OAuth Client ID in Google Cloud Console
  ANDROID_CLIENT_ID: '888442166156-se2mgepkqj0nbm3896i6gum2so1bc06l.apps.googleusercontent.com',
};

/**
 * Get the appropriate Google Client ID for the current platform
 */
export const getGoogleClientId = () => {
  // Check if running in Capacitor (native mobile)
  if (typeof window !== 'undefined' && window.Capacitor) {
    const platform = window.Capacitor.getPlatform();
    
    if (platform === 'ios' && GOOGLE_AUTH_CONFIG.IOS_CLIENT_ID) {
      return GOOGLE_AUTH_CONFIG.IOS_CLIENT_ID;
    }
    
    if (platform === 'android' && GOOGLE_AUTH_CONFIG.ANDROID_CLIENT_ID) {
      return GOOGLE_AUTH_CONFIG.ANDROID_CLIENT_ID;
    }
  }
  
  // Default to web client ID for web, Electron, and mobile fallback
  return GOOGLE_AUTH_CONFIG.WEB_CLIENT_ID;
};

/**
 * Get the server client ID (always use web client ID for backend verification)
 */
export const getServerClientId = () => {
  return GOOGLE_AUTH_CONFIG.WEB_CLIENT_ID;
};

/**
 * Sign in with Apple — public identifiers.
 *
 * SERVICES_ID is used for web (Apple JS SDK) and Electron (OAuth redirect).
 * iOS native uses the bundle ID directly via the Capacitor plugin.
 *
 * Backend verifies tokens against APPLE_SERVICES_ID (web/Electron) or
 * APPLE_APP_ID (iOS native). Both are set as env vars on the backend.
 */
export const APPLE_AUTH_CONFIG = {
  // TODO[apple-portal]: replace placeholder once the Services ID is created.
  SERVICES_ID: 'com.realitymoss.steadily.signin',

  // Native iOS uses the bundle ID — matches capacitor.config.ts appId.
  NATIVE_BUNDLE_ID: 'com.realitymoss.steadily',

  // Apple requires HTTPS for production redirect URIs. The popup posts back
  // via postMessage so this URI is rarely actually hit by users — it's just
  // the registered allowlist entry.
  REDIRECT_URI: 'https://steadily.me/auth/apple/callback',

  // Electron flow: backend relay forwards the form_post to localhost:49494.
  ELECTRON_REDIRECT_URI: 'https://backend.steadily.me/api/auth/apple/electron-callback',

  // Requested scopes — Apple only returns name/email on FIRST sign-in.
  SCOPE: 'name email',
};
